import api from './api';

export const eventService = {
  async getEvents(weddingId, organizationId) {
    const response = await api.get(`/api/events?wedding_id=${weddingId}&organization_id=${organizationId}`);
    return response.data;
  },

  async getEvent(eventId) {
    const response = await api.get(`/api/events/${eventId}`);
    return response.data;
  },

  async createEvent(weddingId, organizationId, eventData) {
    const response = await api.post(`/api/events?wedding_id=${weddingId}&organization_id=${organizationId}`, eventData);
    return response.data;
  },

  async updateEvent(eventId, eventData) {
    const response = await api.put(`/api/events/${eventId}`, eventData);
    return response.data;
  },

  async deleteEvent(eventId) {
    const response = await api.delete(`/api/events/${eventId}`);
    return response.data;
  },

  async updateEventVendors(eventId, vendorIds) {
    const response = await api.patch(`/api/events/${eventId}/vendors`, {
      vendor_ids: vendorIds
    });
    return response.data;
  }
};
